import React from 'react';
import { Paper, Stack } from '@facet-wealth/design';
import Chip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Chip';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import UpdatedScenarioChart from 'Components/ComponentLibrary/Organisms/UpdatedScenarioChart';
import { useIncludedRelationshipContext } from 'Views/Page/Contexts/IncludedRelationshipContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const useStyles = buildUseStyles('Content', (theme) => ({
  activeChip: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.success.main,
    flexShrink: 0,
  },
  icon: {
    color: theme.palette.common.white,
  },
}));

const Content = () => {
  const {
    relationshipCollection,
  } = useIncludedRelationshipContext();
  const classes = useStyles();

  const chartDataResource = relationshipCollection.resources().head();
  if (!chartDataResource) return null;

  return (
    <Paper width="100%" padding={400}>
      <Stack alignItems="center" justifyContent="space-between">
        <Typography variant="h4">
          {chartDataResource.attr('title')}
        </Typography>
        <Chip label="Active" icon={<CheckCircleIcon className={classes.icon} />} className={classes.activeChip} />
      </Stack>
      <Box
        height={200}
        width="100%"
        display="flex"
        flexDirection="column"
      >
        <UpdatedScenarioChart
          chartDataResource={chartDataResource}
        />
      </Box>
    </Paper>
  );
};

export default Content;
